export const UNSUBSCRIBE_ALL = 'unsubscribe_all';
export const DECLINE_UNSUBSCRIBE_ALL = 'decline_unsubscribe_all';
export const DOWN_FOR_MAINTENANCE = 'down_for_maintenance';
export const EMPTY_SUB_LIST = 'empty_sub_list';
export const USER_NOT_FOUND = 'user_not_found';
export const FAILED_TO_UPDATE_PREFERENCES = 'failed_to_update_preferences';
export const UPDATE_PREFERENCES = 'update_preferences';
export const UNSUBSCRIBE = 'unsubscribe';
export const SUBSCRIBE = 'subscribe';
export const PREFERENCES_CENTER_NAVIGATION = 'preferences_center_navigation';
export const ACCEPT_CONSENT = 'accept_consent';
export const DECLINE_CONSENT = 'decline_consent';
export const CONFIRM_CONSENT_PR_UNSUB_CONSENT = 'confirm_consent_pr_unsub';
export const DECLINE_CONSENT_PR_UNSUB_CONSENT = 'decline_consent_pr_unsub';
export const REVOKE_ALL_CONSENT = 'revoke_all_consent';
export const SUBSCRIBE_GROUP = 'subscribe_group';
export const UNSUBSCRIBE_GROUP = 'unsubscribe_group';
export const SELECT_LANGUAGE = 'select_language';
export const REVOKE_CONSENT = 'revoke_consent';
export const SWITCH_TAB = 'switch_tab';
export const CONFIRM_DOUBLE_OPT_IN = 'confirm_double_opt_in';
export const SUBSCRIBE_PRODUCT_INVITATIONS_WARNING = 'subscribe_product_invitations_warning';
